import { useSearchParams } from "react-router-dom";

import { makeRequest } from "../../utils/request";
import { RestList, View } from "../../components/base";
import { User } from "../../redux/reducers/userSlice";

export const AdminOrganizationsPage = () => {
  const [searchParams] = useSearchParams();
  const isPanelOpen = searchParams.has("id");

  const search = async (query: string) => {
    try {
      const { data } = await makeRequest<{ data: User[] }>(`/v1/organizations/search?q=${query}`);
      return data.map((user) => user.id);
    } catch (error) {
      console.error("Error searching users:", error);
    }
    return [];
  };

  return (
    <View className="h-full w-full bg-gray-50 dark:bg-slate-900">
      <div className={`h-full w-full relative ${isPanelOpen ? "pr-[400px]" : ""} transition-all duration-300`}>
        <RestList
          className="h-full w-full"
          entityName="organization"
          search={search}
          fields={[
            {
              name: "id",
              label: "ID",
              readOnly: true,
            },
            {
              name: "name",
              label: "Name",
            },
            {
              name: "agentsEnabled",
              label: "Agents Enabled",
              type: "checkbox",
            },
            {
              name: "billingEnabled",
              label: "Billing Enabled",
              type: "checkbox",
            },
            {
              name: "sessionCostPerMinute",
              label: "Session Cost ($/min)",
              type: "number",
            },
            {
              name: "tokenCostMultiplier",
              label: "Token Cost Multiplier",
              type: "number",
            },
          ]}
        />
      </div>
    </View>
  );
};
